exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".global-quote-portrait.quote-background{background-position:top;background-repeat:no-repeat;background-size:cover}", ""]);

